module.exports = __webpack_public_path__ + "img/celuaplicacion.ee547e61.png";